/* RESPONSIBLE TEAM: team-reporting */

/**
 * Calculates appropriate tick interval for duration-based y-axis.
 * Ensures ticks are at clean intervals:
 * - Seconds: 1, 2, 5, 10, 30 seconds
 * - Minutes: 1, 5, 15, 30, 45 minutes
 * - Hours: 1, 1.5, 3, 5, 10 hours
 * - Days: 1, 2, 5 days
 */

const PREFERRED_TICKS_NUMBER = 2;
const DESIRED_MAX_NUMBER_OF_TICKS = 5;

interface Interval {
  description: string;
  value: number;
}

const DURATION_INTERVALS: Interval[] = [
  { description: '1 second', value: 1 },
  { description: '2 seconds', value: 2 },
  { description: '5 seconds', value: 5 },
  { description: '10 seconds', value: 10 },
  { description: '30 seconds', value: 30 },
  { description: '1 minute', value: 60 },
  { description: '5 minutes', value: 60 * 5 },
  { description: '15 minutes', value: 60 * 15 },
  { description: '30 minutes', value: 60 * 30 },
  { description: '45 minutes', value: 60 * 45 },
  { description: '1 hour', value: 60 * 60 },
  { description: '1 hour 30 minutes', value: 60 * 90 },
  { description: '3 hours', value: 60 * 60 * 3 },
  { description: '5 hours', value: 60 * 60 * 5 },
  { description: '10 hours', value: 60 * 60 * 10 },
  { description: '1 day', value: 60 * 60 * 24 },
  { description: '2 days', value: 60 * 60 * 24 * 2 },
  { description: '5 days', value: 60 * 60 * 24 * 5 },
];

export function getDurationTickInterval(min: number, max: number): number | undefined {
  let bestInterval: number | undefined = undefined;
  const diff = max - min;

  for (const { value } of DURATION_INTERVALS) {
    const potentialNumberOfTicks = Math.floor(diff / value);
    if (
      potentialNumberOfTicks <= DESIRED_MAX_NUMBER_OF_TICKS &&
      potentialNumberOfTicks >= PREFERRED_TICKS_NUMBER
    ) {
      bestInterval = value;
    }
  }

  return bestInterval;
}
